export const videosSelector = ({
  content: {
    videos: { items, loading },
  },
}) => ({ videos: items, loading });
export const gendersSelector = ({ content: { genders } }) => genders;
